import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const homeRouteRef = createRouteRef();

// "/" renders the Provision VM template card. The sidebar's "Home" item
// (and every redirect-to-root, e.g. unauthorized users) lands here.
const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    routeRef: homeRouteRef,
    noHeader: true,
    loader: async () => {
      const { HomePage } = await import('./HomePage');
      return <HomePage />;
    },
  },
});

export const homePlugin = createFrontendPlugin({
  pluginId: 'home',
  extensions: [homePage],
});
